import * as  React from 'react';
import { Grid, Row } from 'react-bootstrap';
import { File } from '../../store/types';
import { ColumnsCount } from './types';
import {Tile,maxColNb} from './Tile';
import './index.css';

interface TilesProps {
    files: Array<File>;
    deleteFile: (index: number) => void;
    downloadFile: (index: number) => void;
    openGallery: (index: number) =>void;
    nCols: ColumnsCount;
};

class Tiles extends React.Component<TilesProps> {

  constructor(props: TilesProps) {
      super(props);
  }

  render() {
    return (
      <Grid>
        {this.generateTiles(this.props.files, this.props.nCols,maxColNb)}
      </Grid>
    );
  }

  private generateTiles(files: Array<File>, nCols: ColumnsCount,maxColNb: number) {
    
    const cols = [];
    for(let i=0;i<files.length;i++) {
      cols.push(
        <Tile
        key={i}
        index={i}
        nCols={nCols}
        file={files[i]}
        deleteFile={this.props.deleteFile}
        downloadFile={this.props.downloadFile}
        openGallery={this.props.openGallery}
        />
        );
    }
    return [<Row className="show-grid" key={0}>{cols}</Row>];
  }

}

export default Tiles;



// WEBPACK FOOTER //
// ./src/components/fileeditor/Tiles.tsx